export default "__VITE_ASSET__BpNeCd4X__"